<template>
  <div>
    <div class="content">
      <!-- 项目介绍-->
      <div class="bg_fff mb_5">
        <img :src="itemList.thumb_frist" alt />
        <div class="itemList_content">
          <p class="itemList_title">{{itemList.title}}</p>
          <p class="itemList_price">
            <span>￥{{itemList.price}}</span>
            {{itemList.itemtime}}分钟/次
          </p>
        </div>
        <div class="item__tableBox border">
          <!-- <table border="0" cellspacing="0" cellpadding="0">
            <tr><th>时长</th><th>技师</th><th>资深技师</th><th>首席技师</th></tr>
            <tr><td>30分钟/次</td><td>¥269.00</td><td>¥269.00</td><td>¥269.00</td></tr>
            <tr><td>30分钟/次</td><td>¥269.00</td><td>¥269.00</td><td>¥269.00</td></tr>
          </table>-->

          <table border="0" cellspacing="0" cellpadding="0">
            <thead class="navbar-inner">
              <tr>
                <th style>时长</th>
                <th
                  v-for="(tl,tlindex) in tech_level"
                  :key="tlindex"
                  style
                  class="tech_level"
                >{{tl.title}}</th>
              </tr>
            </thead>
            <tbody class="guige_tbody">
              <tr v-for="(op,opk) in option" :key="opk">
                <td>
                  {{opk}}
                  <span>/分钟</span>
                </td>
                <td v-for="(op_c,opk_c) in op" :key="opk_c" @click="jump_tech(op_c.tech_level)">
                  <span>￥</span>
                  <span v-if="op_c.use==1">{{op_c.price}}</span>
                  <span v-else>暂无服务</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- 详情介绍-->
      <div class="mb_5 storeDetails__intro">
        <div class="intro_title">
          <span class="title__tag">详情介绍</span>
        </div>
        <div class="itemDetails__content bt_1">
          <div v-html="itemList.content"></div>
          <!-- <img src="/static/img/itemList_img1.png" alt=""> -->
        </div>
      </div>
    </div>
    <!-- 底部组件-->
    <bookFooter></bookFooter>
  </div>
</template>

<script>
import bookFooter from "@/components/bookFooter";
export default {
  name: "itemDetails",
  components: { bookFooter },
  data() {
    return {
      store_id: 0,
      service_id: 0,
      tech_level: [],
      option: [],
      //项目列表
      itemList: [
        {
          img: "/static/img/itemList_img1.png",
          title: "体验按摩",
          price: "39.00",
          time: "15"
        }
      ]
    };
  },
  created() {
    this.service_id = this.$route.query.service_id;
    this.store_id = this.$route.query.store_id;

    this.axios({
      url: this.api.service.service_detail,
      data: {
        id: this.service_id
      }
    }).then(res => {
      if (res.error === 0) {
        let p = new Promise((resolve, reject) => {
          this.itemList = res.service;
          this.tech_level = res.tech_level;
          this.option = res.option;
          resolve("成功");
        });

        p.then(data => {
          this.share();
        });
      }
    });
  },
  methods: {
    jump_tech(level_id) {
      this.$router.push({
        path: "technicianList",
        query: {
          level_id: level_id,
          service_id: this.service_id,
          store_id: this.store_id
        }
      });
    },
    share() {
      console.log(this.itemList.title);
      console.log(this.itemList.thumb_frist);
      console.log(window.location.href);
      this.axios({
        url: this.api.index.shareconfig
      }).then(res => {
        if (res.error === 0) {
          this.wx.wxShare({
            title: this.itemList.title,
            desc: res.shareconfig.desc,
            imgUrl: this.itemList.thumb_frist,
            link: window.location.href,
            toast: "hide"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/store.css";
@import "../../../assets/css/item.css"; /*(服务)项目样式*/
.itemList_content {
  padding: 0.5rem 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/book/item/itemDetails.vue